import styled from "styled-components";

const LoaderContainer = styled.div`
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormSubmitButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export { LoaderContainer, FormSubmitButtonContainer };
